import { render, staticRenderFns } from "./Schools.vue?vue&type=template&id=737da71c&scoped=true"
import script from "./Schools.vue?vue&type=script&lang=js"
export * from "./Schools.vue?vue&type=script&lang=js"
import style0 from "./Schools.vue?vue&type=style&index=0&id=737da71c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "737da71c",
  null
  
)

export default component.exports